export default {
  hero: {
    tagline: "زندگی زیباست اگر",
    taglineHighlight: "زیبا رفتار کنی",
    subtitle: "جایی که نوآوری و ظرافت در هر راه‌حلی که می‌سازیم به هم می‌رسند",
    scroll: "اسکرول کنید",
  },
  banner: {
    brandName: "بورا",
    imageAlt: "نمایش برند بورا",
    cards: {
      faranack: { name: "فرانک", role: "توسعه‌دهنده فرانت‌اند و پژوهشگر یادگیری ماشین" },
      javad: { name: "جواد", role: "توسعه‌دهنده فول‌استک و مهندس الکترونیک" },
    },
    taglinePrefix: "این فقط یک اسم نیست؛ این یک",
    taglineHighlight: "تعهد به کیفیت",
    taglineSuffix: "و نوآوری‌ست.",
  },
  about: {
    heading: "درباره",
    headingHighlight: "ما",
    subheading: "دو نوآور پرشور که برای چالش‌های امروز، راه‌حل‌های پایدار می‌سازند",
    story: {
      title: "داستان ما",
      lead: "توسعه فرانت‌اند و بک‌اند، اینترنت اشیا و سیستم‌های امبدد.",
      body: "تخصص ما صنایع مختلفی از جمله خرده‌فروشی، سلامت دیجیتال و آموزش را در بر می‌گیرد و راه‌حل‌هایی نوآورانه با تاثیر واقعی ارائه می‌دهیم.",
    },
    mission: {
      title: "ماموریت ما",
      body: "ساخت راه‌حل‌های فناورانه نوآورانه، پایدار و اثرگذار که مشکلات واقعی را حل می‌کنند و کسب‌وکارها را برای رشد در عصر دیجیتال توانمند می‌سازند.",
    },
    stats: {
      teamMembers: "عضو تیم",
      projects: "پروژه",
      yearsExperience: "سال تجربه",
      clientSatisfaction: "رضایت مشتری",
    },
    expertiseTitle: "تخصص ما",
    skills: {
      dataScience: "علم داده",
      webDevelopment: "توسعه وب",
      mobileApplications: "اپلیکیشن‌های موبایل",
      iotSolutions: "راه‌حل‌های اینترنت اشیا",
      embeddedSystems: "سیستم‌های امبدد",
      aiMl: "هوش مصنوعی و یادگیری ماشین",
      cloudArchitecture: "معماری ابری",
      devops: "دواپس",
    },
  },
  iot: {
    headingPrefix: "این حرفه",
    headingHighlight: "ماست",
    subtitle: "خلق راه‌حل‌های هوشمند از طریق فناوری نوآورانه و مهندسی خلاقانه",
    indicators: {
      iotSolutions: "راه‌حل‌های اینترنت اشیا",
      smartEngineering: "مهندسی هوشمند",
      innovation: "نوآوری",
    },
  },
  whatWeDo: {
    heading: "کارهایی که انجام می‌دهیم",
    subtitle:
      "پیش‌برنده نوآوری از طریق خدمات تخصصی متناسب با چالش‌ها و اهداف منحصر به فرد شما.",
    items: {
      softwareDevelopment: {
        title: "توسعه نرم‌افزار",
        description:
          "به‌عنوان توسعه‌دهندگان فرانت‌اند و بک‌اند، راه‌حل‌های نرم‌افزاری نوآورانه می‌سازیم و تجربه‌های کاربری بصری و عملکردهای سمت سرور مطمئن را برای کسب‌وکارها و کاربران فراهم می‌کنیم.",
      },
      artificialIntelligence: {
        title: "هوش مصنوعی",
        description:
          "پروژه‌های هوش مصنوعی ما از فناوری روز برای ساخت سیستم‌های هوشمندی استفاده می‌کند که یاد می‌گیرند، تطبیق پیدا می‌کنند و مسائل پیچیده را حل می‌کنند و نوآوری را در صنایع مختلف پیش می‌برند.",
      },
      internetOfThings: {
        title: "اینترنت اشیا",
        description:
          "پروژه‌های اینترنت اشیای ما دستگاه‌های هوشمند و متصل می‌سازد که ارتباط و تبادل داده بی‌وقفه را ممکن می‌کند، کارایی را افزایش می‌دهد و تجربه‌های روزمره را متحول می‌سازد.",
      },
      electronicEngineering: {
        title: "مهندسی الکترونیک",
        description:
          "پروژه‌های مهندسی الکترونیک ما شامل طراحی و توسعه سیستم‌ها، مدارها و دستگاه‌های الکترونیکی نوآورانه برای پاسخ به چالش‌های واقعی و ارتقای پیشرفت فناوری است.",
      },
    },
  },
  contact: {
    heading: "با ما در ارتباط باشید",
    subtitle: "بیایید با هم چیزی خارق‌العاده بسازیم. برای تحقق ایده شما بی‌صبرانه منتظریم.",
    methods: {
      telegram: { title: "تلگرام", desc: "گفتگوی سریع و پشتیبانی" },
      email: { title: "ایمیل", desc: "درخواست‌های تفصیلی" },
    },
    footerNote: "از بازدید شما سپاسگزاریم • آماده نوآوری با هم",
  },
};
